package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.repository.ImageStorageRepository

/**
 * Use case for deleting a character avatar image.
 */
class DeleteCharacterImageUseCase(
    private val imageStorageRepository: ImageStorageRepository
) {
    /**
     * Deletes an image for a character.
     * @param userId The ID of the user who owns the character
     * @param characterId The ID of the character
     * @return Result indicating success or failure
     */
    suspend operator fun invoke(
        userId: String,
        characterId: String
    ): Result<Unit> {
        return imageStorageRepository.delete(ImageTarget.CharacterAvatar(userId, characterId))
    }
}
